const bookingComponentLoaders = Object.freeze({
  'booking.reservation-workspace': async () => {
    const module = await import('./booking-workspace-component.js');
    return module.BookingWorkspaceComponent;
  },
});

export default bookingComponentLoaders;
